// extracted by mini-css-extract-plugin
export default {"chartWrapper":"WeatherHoursForecast_chartWrapper__85LRv","chartTitle":"WeatherHoursForecast_chartTitle__aKgZr","temperaturePoint":"WeatherHoursForecast_temperaturePoint__Dy-w6"};